import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';
import InvestmentApproachSections from './Layout/sections';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'lg', align: 'center' },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'md', align: 'center' },
  }, overrideReadOnly)
  .nameOverride('sections', {
    _component: () => InvestmentApproachSections,
  }, overrideReadOnly);

export default metaOverrideSet;
